// SoldBanner.jsx
// Component for displaying sold status banner - Modernized

import React from 'react';
import { COLORS, LAYOUT } from '../../constants';

// Modern SVG Icons
const CheckCircleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22,4 12,14.01 9,11.01"></polyline>
  </svg>
);

const SoldBanner = ({ listing }) => {
  if (listing.status !== 'sold') return null;

  return (
    <div style={modernStyles.bannerContainer}>
      <div style={modernStyles.banner}>
        <div style={modernStyles.iconContainer}>
          <CheckCircleIcon />
        </div>
        <div style={modernStyles.content}>
          <h3 style={modernStyles.title}>SOLD OUT</h3>
          <p style={modernStyles.subtitle}>
            This item has been purchased and is no longer available
          </p>
        </div>
      </div>
    </div>
  );
};

// Modern styles
const modernStyles = {
  bannerContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: COLORS.grayLight,
    padding: `0 ${LAYOUT.spacing.lg}`,
    marginBottom: LAYOUT.spacing.xl,
  },
  banner: {
    maxWidth: '1400px',
    margin: '0 auto',
    background: `linear-gradient(135deg, ${COLORS.primary}, #9d0d1d)`,
    color: COLORS.white,
    borderRadius: LAYOUT.borderRadius.lg,
    padding: LAYOUT.spacing.xl,
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.lg,
    boxShadow: `0 8px 32px ${COLORS.primary}30`,
    border: `2px solid ${COLORS.primary}`,
  },
  iconContainer: {
    width: '56px',
    height: '56px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: LAYOUT.spacing.xs,
    letterSpacing: '1px',
  },
  subtitle: {
    fontSize: '1rem',
    opacity: 0.9,
    margin: 0,
    fontWeight: '500',
  },
};

export default SoldBanner;